/** BE validates keys by name (no flag); FE mirrors it. Compare case-insensitively. */
export const MANN_CO_KEY_NAME = 'Mann Co. Supply Crate Key';
export const COINFLIP_MAX_ITEMS = 20;
export const COINFLIP_PURE_KEY_ONLY_MAX_ITEMS = 100;
/** Key count at which non-keys become unavailable in key-only pure create. */
export const COINFLIP_NON_KEY_BLOCK_AT_KEYS = 20;

export function isMannCoKey(name: string | null | undefined): boolean {
  return !!name && name.toLowerCase() === MANN_CO_KEY_NAME.toLowerCase();
}
